<template>
  <div style="margin-top:40px;margin-bottom:50px;">
    <ul class="uk-child-width-expand" uk-tab>
      <li><a href="#">수주 단계</a></li>
      <li><a href="#">기획 단계</a></li>
      <li class="uk-active"><a href="#">디자인 단계</a></li>
      <li><a href="#">개발 단계</a></li>
      <li><a href="#">완료 및 납품</a></li>
    </ul>
  </div>
</template>